import { PAGE_NOTE } from "./misc/constants";
import BrandContract from "./brand-contract";

// Brands only: publishers are sent the brand's tripartite agreement from the
// brand detail page's Contract tab, which is where every row here leads.
const Contracts = () => (
    <div className="p-6">
        <h1 className="text-2xl font-semibold tracking-tight">Contracts</h1>
        <p className="mt-1 max-w-3xl text-sm text-muted">{PAGE_NOTE}</p>

        <div className="mt-6">
            <BrandContract />
        </div>
    </div>
);

export default Contracts;
